export default "__VITE_ASSET__BWumzu9L__"